__turbopack_context__.v({
  "className": "geist_642635ac-module__LqSHgW__className",
  "variable": "geist_642635ac-module__LqSHgW__variable",
});
